import {Input, Select} from "antd";
import {PRESET_TRIGGER_DELAYS} from "../../messageCreationFlow/step2/presetTriggerDelays";
import {PRESET_TRIGGER_DELAYS_UNITS} from "../../messageCreationFlow/step2/presetTriggerDelaysUnits";
import {useEffect, useState} from "react";
import "./time-picker.css";
import BigPicker from "../bigPicker/BigPicker";

interface TimePickerProps {
    title: string;
    description?: string;
    value: number | null;
    setValue: (newVal: number) => void;
    placeholder?: string;
    includeImmediateValue?: boolean;
}

const TimePicker = ({ title, description, value, setValue, placeholder, includeImmediateValue = false }: TimePickerProps) => {
    const [dropdownValue, setDropdownValue] = useState(value);
    const [customValue, setCustomTriggerDelay] = useState('5');
    const [timePickerUnit, setTriggerDelayUnit] = useState('minutes');

    useEffect(() => {
        dropdownValue === null && value !== undefined && setDropdownValue(value);
    }, [value]);

    const isCustomTimePicker = dropdownValue === -1;

    useEffect(() => {
        if(dropdownValue === -1) {
            const multiplyBy = PRESET_TRIGGER_DELAYS_UNITS.find(unit => unit.value === timePickerUnit)?.multiplyBy || 1;
            setValue(parseInt(customValue)*60*multiplyBy);
        } else {
            setValue((dropdownValue || 0)*60);
        }
    }, [dropdownValue, customValue, timePickerUnit]);

    const triggerDelayOptions = includeImmediateValue ? [{ value: 0, label: 'Immediately' }, ...PRESET_TRIGGER_DELAYS] : PRESET_TRIGGER_DELAYS;

    return (
        <div className="field-container">
            <div className="field-title">
                {title}
            </div>
            {description && <div className="field-description">
                {description}
            </div>}
            <BigPicker value={dropdownValue} setValue={(newValue) => setDropdownValue(newValue as number)} placeholder={placeholder} options={triggerDelayOptions} selectClassName="time-picker-select" optionClassName="time-picker-option" />
            {isCustomTimePicker ? <div className="time-picker-custom-selection">
                <Input className="time-picker-custom-input" value={customValue} onChange={(event) => setCustomTriggerDelay(event.target.value)} />
                <BigPicker value={timePickerUnit} setValue={(newValue) => setTriggerDelayUnit(newValue as string)} options={PRESET_TRIGGER_DELAYS_UNITS} selectClassName="time-picker-select time-picker-unit-select" />
            </div> : null}
        </div>
    );
}

export default TimePicker;